// extracted by mini-css-extract-plugin
var _1 = "Uj03YV";
var _2 = "fTqtpq";
var _3 = "f_Ojb2";
var _4 = "cne5x0";
var _5 = "TMaZKx";
var _6 = "ghkmrW";
var _7 = "QJwzbC";
var _8 = "OmSqA8";
var _9 = "duKcHz";
var _a = "b8MG6d";
export { _1 as "ease-transition", _2 as "gradient-titanic-80", _3 as "linear-transition-05", _4 as "rounded", _5 as "shadow-medium-titanic", _6 as "shadow-medium-titanic-hover", _7 as "shadow-titanic-1", _8 as "shadow-white", _9 as "tabs", _a as "tabsContainer" }
